<main class="main" id="main">
    <ng-content></ng-content>
</main>
